const RulesZH = `
  <h2 class="info-about-static__title">
    <b>“金砖国家数学联欢节”规则和对教师的建议</b>
  </h2>
  <h3 class="info-about-static__pre-title"><b>联欢节什么时间举行？</b></h3>
  <p class="info-about-static__text">联欢节将分两轮进行：“快乐健身”和“激情展示”。“快乐健身”不影响“激情展示”的成绩。</p>
  <p class="info-about-static__text">对于 1-12 年级的学生，预选赛和主赛将在 2022 年秋季举行。</p>
  <h3 class="info-about-static__pre-title"><b>教师如何登录？</b></h3>
  <p class="info-about-static__text">
    参加联欢节要在bricsmath.com上进行注册。请注意，您注册时使用的邮箱即为登陆账号和密码。
    <span class="break-text"><br></span>
    您可以在个人中心修改密码。
  </p>
  <h3 class="info-about-static__pre-title"><b>学生如何登录？</b></h3>
  <p class="info-about-static__text">
    使用账号和密码登录bricsmath.com的个人中心，创建班级名单。
    <span class="break-text"><br></span>
    由教师输入每个学生的姓名和性别，系统将自动生成个人账号和密码。
    <span class="break-text"><br></span>
    将账号和密码打印并发给学生，学生可以使用该账号和密码登录并参加快乐热身和激情展示。
    <span class="break-text"><br></span>
    教师为学生注册没有人数限制。
  </p>
  <h3 class="info-about-static__pre-title"><b>在学校如何参加联欢节？</b></h3>
  <p class="info-about-static__text">
    参加联欢节只需要一台可联网的电脑设备（或者笔记本电脑以及平板电脑）并使用现代浏览器进行作答。
  </p>
  <p class="info-about-static__text">参与者每人一台电脑，在激情展示开始之前要检查电脑的运行状况。</p>
  <p class="info-about-static__text">
    每个学生只有一次参赛机会，不能重复参加。因此我们强烈建议在联欢节开始两天前进行热身练习。
    <span class="break-text"><br></span>
    让您的学生坐在电脑前，并为他们进行解释。让学生用您发给他们的账号和密码登录bricsmath.com的网页，进行快乐热身练习。
    <span class="break-text"><br></span>
    如果有任何技术问题，可以跟我们的系统管理员进行联系。
    <span class="break-text"><br></span>
    如有必要，请更新浏览器或检查网络连接。
  </p>
  <h3 class="info-about-static__pre-title"><b>浏览器</b></h3>
  <p class="info-about-static__text">如果您用电脑或笔记本电脑，我们推荐安装<b><a href="https://ie.sogou.com" target="_blank">搜狗</a>浏览器最新版。</b></p>
  <p class="info-about-static__text">也可以使用百度浏览器 (6以上的版本)、 Firefox (43以上的版本)、 Safari (9以上的版本)。</p>
  <p class="info-about-static__text">如果您是iPad平板电脑 ，可以使用Safari 和iOS 9以上的移动操作系统。</p>
  <p class="info-about-static__text">我们不能保证其他浏览器的兼容性。</p>
`

export default RulesZH
